/* eslint-disable no-unused-vars */
import { ChevronLeftIcon } from '@heroicons/react/solid';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

function CourseContentLeft() {
  const { t } = useTranslation();
  return (
    <ul className="m-3 md:m-8 flex-col space-y-6">
      <Link to={`/courses`}>
        <button className="bg-sky rounded-md text-white p-2 hover:bg-sky-dark shadow-md hover:shadow-lg flex gap-2">
          <ChevronLeftIcon className="h-5" />
          {t('overview')}
        </button>
      </Link>
    </ul>
  );
}

CourseContentLeft.propTypes = {};

export default CourseContentLeft;
